<template>
  <div class="container">
    <app-header title="用户注册"/>
    <div class="main">
      <img src="@/assets/avatar.png"  width="76px" height="76px">
      <div class="title">我是蓝天白云，我要成为其中一</div>
    </div>
    <div class="login">
      <van-form>
        <van-field
          name="手机号码"
          label="手机号码"
          placeholder="请获取手机号码"
          :rules="[{ required: true, message: '请获取手机号码' }]"
        >
          <template #button>
            <van-button class="panel" size="small" type="default" @click="show = true">获取手机号</van-button>
          </template>
        </van-field>
        <div class="tip">
          <span style="color: #0D75CF">《用户条款协议》</span>
        </div>
        <div class="submit">
          <span style="color: #ffffff">提交</span>
        </div>
        <div class="look" style="margin-top: 22px;">
          <span style="color: #333333" @click="home">暂不注册 , 去逛逛</span>
        </div>
      </van-form>
    </div>
    <van-popup v-model="show" round position="bottom" :style="{ height: '75%' }" >
      <div class="popup">
        <div style="padding: 22px;">商城   申请使用</div>
        <div class="hintPhone">你的手机号码</div>
        <div style="height:1px;background:rgba(243,243,243,1);margin-top: 23px"></div>
        <div class="phone"  v-for="i in 3" :key="i">
          <div class="phones">13259622239</div>
          <div class="phoneHint">微信绑定号码</div>
        </div>
        <div style="height:1px;background:rgba(243,243,243,1);margin-top: 23px"></div>
        <div style="color: #5D6282;padding-top: 10px;padding-left: 22px" @click="phone">管理员手机号</div>
        <div class="all">
          <div class="cli" style="background:rgba(237,237,237,1);color: #07C160">拒绝</div>
          <div class="cli" style="background:rgba(7,193,96,1);color: #ffffff;">允许</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'Register',
  data() {
    return {
      show: false
    }
  },
  methods: {
    home() {
      this.$router.push('/home')
    },
    phone() {
      this.$router.push('/phone')
    }
  }
}
</script>

<style lang="less" scoped>
  .container{
    .main{
      height: 200px;
      flex-direction: column;
      justify-content: center;
      text-align: center;
      margin-top: 41px;
      .title{
        height:22px;
        font-size:16px;
        font-family:PingFang SC;
        text-align: center;
        font-weight:500;
        line-height:22px;
        color:rgba(102,102,102,1);
        opacity:1;
      }
    }

    .login{
      .panel{
        width:88px;
        height:30px;
        background:rgba(7,193,96,1);
        border:1px solid rgba(7,193,96,1);
        opacity:1;
        border-radius:2px;
        color: #ffffff;
      }
      .submit{
        width:351px;
        height:40px;
        line-height: 40px;
        background:linear-gradient(0deg,rgba(244,4,66,1) 0%,rgba(226,23,75,0.73) 100%);
        opacity:1;
        border-radius:4px;
        text-align: center;
        margin: auto;
      }
      .look{
        width:351px;
        height:40px;
        line-height: 40px;
        text-align: center;
        border:1px solid rgba(136,137,136,1);
        opacity:1;
        border-radius:4px;
        margin: auto;
      }
      .tip{
        display: flex;
        flex-direction: row;
        align-items: center;
        height:17px;
        font-size:12px;
        font-family:PingFang SC;
        font-weight:400;
        color:#333333;
        padding: 12px 0;
        margin-bottom: 103px;
        span{
          margin-left: 10px;
        }
      }
    }

    .popup{
      .hintPhone{
        padding: 15px;
        width:144px;
        height:33px;
        font-size:24px;
        font-family:PingFang SC;
        font-weight:bold;
        line-height:33px;
        color:rgba(51,51,51,1);
        opacity:1;
      }
      .phone{
        padding: 12px;
        display: flex;
        .phones{
          width:106px;
          height:22px;
          font-size:16px;
          font-family:PingFang SC;
          font-weight:500;
          line-height:22px;
          color:#333333;
          opacity:1;
        }
        phoneHint{
          width:96px;
          height:22px;
          font-size:16px;
          font-family:PingFang SC;
          font-weight:500;
          line-height:22px;
          color:#C7C7C7;
          opacity:1;
        }
      }
      .all{
        display: flex;
        padding: 22px;
        justify-content: space-between;
        .cli{
          width:159px;
          height:40px;
          opacity:1;
          border-radius:4px;
          text-align: center;
          line-height: 40px;
        }
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/views/login/register.vue